import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { settingsPanelStyles as styles } from './styles';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

class TextDecoration extends Component<IProps, any> {
    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                        <span className={classes.header} style={{ width: 100 }}>
                            {' '}
                            Decoration{' '}
                        </span>
                        <select tyepe="text" value={descriptor.style.textDecorationLine as string} onChange={(e) => (descriptor.style.textDecorationLine = e.target.value)} className={classes.select} style={{ width: 180 }}>
                            <option>none</option>
                            <option>underline</option>
                            <option>overline</option>
                            <option>line-through</option>
                        </select>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                            alignItems: 'center',
                        }}>
                        <span className={classes.header} style={{ width: 100 }}>
                            Text Style{' '}
                        </span>
                        <select type="text" value={descriptor.style.fontStyle as string} onChange={(e) => (descriptor.style.fontStyle = e.target.value)} className={classes.select} style={{ width: 180 }}>
                            <option>normal</option>
                            <option>italic</option>
                            <option> oblique</option>
                        </select>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                            alignItems: 'center',
                        }}>
                        <span className={classes.header} style={{ width: 100 }}>
                            Text Transform
                        </span>
                        <select type="text" value={descriptor.style.textTransform as string} onChange={(e) => (descriptor.style.textTransform = e.target.value)} className={classes.select} style={{ width: 180 }}>
                            <option>none</option>
                            <option>lowercase</option>
                            <option>uppercase</option>
                            <option>capitalize</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(TextDecoration));
